/**
 * Process items to get unique entries based on safeguard ID, keeping the most recent (CIS/NIST version)
 * @param {Array} items - Array of items to process
 * @returns {Array} - Processed unique items with maturity scores
 */
(function($) {
	function processUniqueItemsCIS(items) {
	const itemsMap = items.reduce((acc, item) => {
		const safeguardId = item.safeguardid.S;
		const timestamp = parseInt(item.timestamp.S, 10);

		// Only answer rows count; a row without policystatus (legacy implementation-only
		// shape) made policystatus.N below throw for the whole project.
		if (!item.policystatus) {
			return acc;
		}
		
		// Keep only the most recent item for each safeguardId
		if (!acc[safeguardId] || acc[safeguardId].timestamp < timestamp) {
			acc[safeguardId] = { ...item, timestamp };
		}
		
		return acc;
	}, {});
	
	console.log("processUniqueItems: ", itemsMap);
	
	// Process all items and set maturity score
	const processedItems = Object.values(itemsMap).map(item => {
		const policystatus = parseInt(item.policystatus.N, 10);
		// Set maturity score to null for policy status 1
		item.maturityscore = policystatus === 1 ? null : calculateMaturityScore(policystatus);
		console.log(`Maturity score for safeguard ${item.safeguardid.S}:`, item.maturityscore);
		return item;
	});
	
	return processedItems;
	}

	// Export for use in other modules
	if (typeof module !== 'undefined' && module.exports) {
		module.exports = processUniqueItemsCIS;
	} else if (typeof window !== 'undefined') {
		window.processUniqueItemsCIS = processUniqueItemsCIS;
	}

})(jQuery);
